<header>
    <div class="col-12 top-head">
        <div class="col-3 logo">
            <a href="javascrpit:void(0)" routerLink="/"><img src="assets/images/hayti_logo.png" alt="hayti_logo.png"></a>
        </div>
         <!-- <div style="padding-left: 0px;"  *ngIf="currentUrl == '/publishers' || currentUrl == '/podcasts'" class="col-3 logo">
            <a  *ngIf="currentUrl == '/publishers'" href="javascrpit:void(0)" routerLink="/"><img style="max-width:450px;" src="assets/images/publisher-hayti-icon.png" alt="publisher-hayti-icon.png"></a>
            <a  *ngIf="currentUrl == '/podcasts'" href="javascrpit:void(0)" routerLink="/"><img style="max-width:450px;" src="assets/images/podcast-hayti-icon.png" alt="podcast-hayti-icon.png"></a>
        </div> -->
        <div class="col-6 menu-box">
            <nav class="navbar navbar-inverse">
                <div class="navbar-collapse collapse" id="myNavbar" aria-expanded="false">
                    <ul>
                        <!-- <li><a routerLink="/">Home</a></li> -->
                        <!-- <li><a (click)="setDocTitle( 'About Us | Hayti – News Videos And Podcasts From Black Publishers' )" routerLink="/about-us">About</a></li> -->
                        <li><a class="web-header" (click)="setDocTitle( ' Black Publishers | Submit Black News | Hayti Black News App' )"routerLink="/publishers">Publishers</a></li>
                        <!--<li><a (click)="setDocTitle( 'Hayti News | Hayti - News, Videos and Podcasts from Black Publishers' )"routerLink="/news">News</a></li>-->
                        <!-- <li><a routerLink="/podcasts-web">Podcasts Web</a></li> -->
                        <li><a class="web-header" routerLink="/podcasters">Podcasters</a></li>

                        <li><a class="phone-header" data-toggle="collapse" data-target="#myNavbar" (click)="setDocTitle( ' Black Publishers | Submit Black News | Hayti Black News App' )"routerLink="/publishers">Publishers</a></li>
                        <li><a class="phone-header"  data-toggle="collapse" data-target="#myNavbar" routerLink="/podcasters">Podcasters</a></li>
                    </ul>
                 

                </div>
            </nav>
        </div>
        <div class="col-3 extra-menu">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#myNavbar"
                aria-expanded="false">
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
            <!-- <ul> -->
            <!-- <li>Call Us <a href="#">+123.123.123</a></li> -->
            <!-- <li><a class="btnContact" href="#">Contact Us </a></li> -->
            <!-- </ul> -->
        </div>
    </div>
    <ng-container *ngIf="currentUrl == '/about-us'">
        <div class="col-12 site-inner-banner pl-0 pr-0">
            <div class="container">
                <h1>About us.</h1>
            </div>
        </div>
    </ng-container>
    <!-- <ng-container *ngIf="currentUrl == '/publishers'">
        <div class="col-12 site-inner-banner pl-0 pr-0">
            <div class="container">
                <h1>Publishers: Partner With Hayti</h1>
            </div>
        </div>
    </ng-container> -->
    <ng-container *ngIf="currentUrl == '/press-media'">
        <div class="col-12 site-inner-banner pl-0 pr-0">
            <div class="container">
                <h1>Hayti Press And Media</h1>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="currentUrl == '/contact-us'">
        <div class="col-12 site-inner-banner pl-0 pr-0">
            <div class="container">
                <h1>Contact Us</h1>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="currentUrl == '/privacy-policy'">
        <div class="col-12 site-inner-banner pl-0 pr-0">
            <div class="container">
                <h1>Hayti Privacy Policy</h1>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="currentUrl == '/terms-of-service'">
        <div class="col-12 site-inner-banner pl-0 pr-0">
            <div class="container">
                <h1>Hayti Terms Of Services</h1>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="currentUrl == '/publisher-terms'">
        <div class="col-12 site-inner-banner pl-0 pr-0">
            <div class="container">
                <h1>Hayti Publisher Terms</h1>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="currentUrl == '/podcaster-terms'">
        <div class="col-12 site-inner-banner pl-0 pr-0">
            <div class="container">
                <h1>Hayti Podcaster Terms</h1>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="currentUrl == '/tech-entrepreneurs-news-app-hayti-increases-visibility-black-publishers'">
        <div class="col-12 site-inner-banner pl-0 pr-0">
            <div class="container">
                <h1>Tech Entrepreneur’s News App, Hayti, Increases Visibility for Black Publishers</h1>
            </div>
        </div>
    </ng-container>
    <!-- <ng-container *ngIf="currentUrl == '/podcasts-web'">
       <div class="col-12 site-banner pl-0 pr-0">
				<div class="update-typebanner stylebanner-3">
					<div class="n_and_p_Banner-graphics">
						<img src="assets/images/podcasts/vector-smart-3.png" alt="vector-smart-3">
					</div>
					<div class="n_and_p_Banner">
						<div class="container">
							<div class="left-content">
								<h1>Get <span class="sub-border">More</span> Listeners & Grow Your <span class="sub-border">Show</span></h1>
								<p>Hayti offers a curated collection of the top Black <br>podcasters from around the world.</p>
								<a href="#" class="btn btn-green">Add Your Podcast To Hayti</a>
							</div>
							<div class="imgRight">
								<img src="assets/images/podcasts/slide-vactor-shap.png" alt="slide-vactor-shap">
							</div>
						</div>
					</div>
				</div>
			</div>
    </ng-container> -->

    <ng-container *ngIf="currentUrl == '/'">

        <div class="col-12 site-banner pl-0 pr-0">
            <div class="update-typebanner stylebanner-1">
                <div class="n_and_p_Banner-graphics">
                    <img src="assets/images/vector-smart-1.png" alt="vector-smart-1">
                </div>
                <div class="n_and_p_Banner">
                    <div class="container">
                        <div class="left-content">
                            <h1>News And Podcasts <span class="bordered-title">For The Culture</span></h1>
                            <ul class="button-group">
                                <li><a href="https://play.google.com/store/apps/details?id=hayti.com" class="btn-gpaly"><img src="assets/images/g_play.png" alt="g_play.png"></a></li>
                                <li><a href="https://apps.apple.com/us/app/hayti/id1544792703" class="btn-appstore"><img src="assets/images/ap_store.png" alt="ap_store.png"></a></li>
                            </ul>
                        </div>
                        <div class="imgRight">
                            <img src="assets/images/news-and-product.png" alt="news-and-product">
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="col-12 fullvideo">
            <!-- <div class="video-box"></div> -->
            <!-- <iframe width="100%" src="https://www.youtube.com/embed/gbUmu3j2n1I??autoplay=1" title="YouTube video player" frameborder="0"  allowfullscreen></iframe> -->
            <!-- <iframe width="100%" height="auto" src="https://www.youtube.com/embed/gbUmu3j2n1I?autoplay=1&mute=1&controls=1&loop=1&playlist=gbUmu3j2n1I"  frameborder="0" allow="autoplay;" allowfullscreen></iframe> -->
            <!-- <video autoplay="autoplay" class="fillWidth" height="240" id="backgroundvid" loop="loop" muted="muted" playsinline="" preload="auto" type="video/mp4" width="320"><source src="assets/Hayti_App-gbUmu3j2n1I-1080p-1660096630771_1.mp4" type="video/mp4"></video> -->
            
            <video autoplay="autoplay" class="fillWidth" height="240" id="backgroundvid" loop="loop" [muted]="'muted'" playsinline="" preload="auto" type="video/mp4" width="320"><source src="assets/Hayti_App_Video.mp4" type="video/mp4"></video>
            <!-- <video width="100%" height="100%" controls>
                <source src="assets/Hayti App-gbUmu3j2n1I-1080p-1660096630771.mp4" type="video/mp4">
              </video> -->
            <!-- <a id="view-video" class="video-button fancybox" data-fancybox=""
                href="https://www.youtube.com/watch?v=gbUmu3j2n1I"><img alt="" src="assets/images/icon/play.png"></a> -->
        </div>
    </ng-container>
</header>